import { bind, debounce } from 'lodash';
import utils from '@bigcommerce/stencil-utils';
import urlUtils from '../common/utils/url-utils';
import { defaultModal, ModalEvents } from './modal';
import modalFactory, { alertModal, showAlertModal } from './modal';
import { normalizeFormData } from '../common/utils/api';

export default function (context) {

	function getCartContent(cartItemId, onComplete) {
        const options = {
            template: 'cart/preview',
            params: {
                suggest: cartItemId,
            },
            config: {
                cart: {
                    suggestions: {
                        limit: 4,
                    },
                },
            },
        };

        utils.api.cart.getContent(options, onComplete);
    }

	function updateCartContent(modal, cartItemId, onComplete) {
        getCartContent(cartItemId, (err, response) => {
            if (err) {
                return;
            }

            modal.updateContent(response);

            // Update cart counter
            const $body = $('body');
            const $cartQuantity = $('[data-cart-quantity]', modal.$content);
            const $cartCounter = $('.navUser-action .cart-count');
            const quantity = $cartQuantity.data('cartQuantity') || 0;


            $cartCounter.addClass('cart-count--positive');
            $body.trigger('cart-quantity-update', quantity);

            if (onComplete) {
                onComplete(response);
            }

        });
    }

    function addProductToCart(productId, qty) {
    	const $overlay = $('#modal .loadingOverlay');
		const previewModal = modalFactory('#modal')[0];

		const form = document.createElement('form');
		const hiddenField1 = document.createElement('input');
		hiddenField1.type = 'hidden';
		hiddenField1.name = 'product_id';
		hiddenField1.value = productId;

		form.appendChild(hiddenField1);

		const hiddenField2 = document.createElement('input');
		hiddenField2.type = 'hidden';
		hiddenField2.name = 'qty';
		hiddenField2.value = qty;
		form.appendChild(hiddenField2);

		$overlay.show();

        // Add item to cart
        utils.api.cart.itemAdd(normalizeFormData(new FormData(form)), (err, response) => {
            const errorMessage = err || response.data.error;
            $overlay.hide();

            // Guard statement
            if (errorMessage) {
                // Strip the HTML from the error message
                const tmp = document.createElement('DIV');
                tmp.innerHTML = errorMessage;

                return showAlertModal(tmp.textContent || tmp.innerText);
            }

            // Open preview modal and update content
            if (previewModal) {
                previewModal.open();
                updateCartContent(previewModal, response.data.cart_item.id);
            } else {
                $overlay.show();
                // if no modal, redirect to the cart page
                window.location = (response.data.cart_item.cart_url || context.urls.cart);
            }
        });
    }

	function addToCartBySku(sku, qty) {
		const $overlay = $('#modal .loadingOverlay');
		const previewModal = modalFactory('#modal')[0];

		let productId = sku;
		fetch('/graphql', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + context.settings.storefront_api.token
            },
            body: JSON.stringify({
                query: `
            query MyFirstQuery {
                site {
                product (sku: \"` + sku + `\") {
                    entityId
                }
              }
            }
            `
            }),
        })
        .then(res => res.json())
        .then(json => {
            if (json.data.site.product) {
                productId = json.data.site.product.entityId;
				console.log(productId)

				addProductToCart(productId, qty);
            } else { // sku not exist
                return;
            }
        })
	}

	function addToCartById(productId, qty) {
		console.log(productId)
		addProductToCart(productId, qty);
	}

	window.addToCartBySku = bind(addToCartBySku, this);
	window.addToCartById = bind(addToCartById, this);
}
